// src/pages/ResumePage.jsx
import React from 'react'
export default function ResumePage() {
  return (
    <section>
      <h1>My Résumé</h1>
      {/* embed a PDF or recreate your CV here */}
    </section>
  )
}